import { useCallback } from "react";
import useNotificationStore from "@features/notifications/store/useNotificationStore";

export const useEmptyNotification = () => {
  const [setIsNotificationLoading, setIsNotificationDisplayed] =
    useNotificationStore((store) => [
      store.setIsNotificationLoading,
      store.setIsNotificationDisplayed,
    ]);

  const handleEmptyNotification = useCallback(() => {
    setIsNotificationLoading(false);
    setIsNotificationDisplayed(false);
  }, [setIsNotificationLoading, setIsNotificationDisplayed]);

  return { handleEmptyNotification };
};
